import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getUnitMeasureOptionsAPI } from '../../../api/unitMeasure/unitMeasureAPI'

const UnitMeasureSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
  	const [validSelect, setValidSelect] = useState(false)
	const [unitMeasures, setUnitMeasures] = useState([ // Переніс на бекенд
		// {
		// 	id: 'pieces',
		// 	name: 'шт.'
		// },
		// {
		// 	id: 'packages',
		// 	name: 'уп.'
		// },
		// {
		// 	id: 'meters',
		// 	name: 'м.'
		// },
		// {
		// 	id: 'square_meters',
		// 	name: 'м2'
		// },
		// {
		// 	id: 'centimeters',
		// 	name: 'см.'
		// },
		// {
		// 	id: 'liters',
		// 	name: 'л.'
		// },
		// {
		// 	id: 'milliliters',
		// 	name: 'мл.'
		// },
		// {
		// 	id: 'kilogram',
		// 	name: 'кг.'
		// },
		// {
		// 	id: 'gram',
		// 	name: 'г.'
		// },
	])

	useEffect(() => {
		getUnitMeasures()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUnitMeasures = () => {
		getUnitMeasureOptionsAPI().then(data => {
			setUnitMeasures(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Од. виміру"
        labelId="select__unitMeasure-label"
        id='select__unitMeasure'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Од. виміру'
        // sx={{width: '200px'}}
        options={
			unitMeasures && unitMeasures.length > 0 ? 
				unitMeasures.map(unitMeasure => {
            		return {id: unitMeasure.id, name: unitMeasure.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default UnitMeasureSelectMain